import { useState } from 'react';

export const STORAGE_KEY = 'chats:expanded-groups';

const readExpandedGroupIds = (): Set<string> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? new Set(parsed.filter((id) => typeof id === 'string'))
      : new Set();
  } catch {
    return new Set();
  }
};

export const useExpandedGroups = () => {
  const [expandedGroupIds, setExpandedGroupIds] = useState<Set<string>>(readExpandedGroupIds);

  const toggleGroup = (groupId: string) => {
    setExpandedGroupIds((prev) => {
      const next = new Set(prev);
      if (next.has(groupId)) {
        next.delete(groupId);
      } else {
        next.add(groupId);
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(next)));
      return next;
    });
  };

  return { expandedGroupIds, toggleGroup };
};
